<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-4">
          <!-- <label for="sessionDate" class="form-label">Email address</label>
          <input type="date" class="form-control" id="sessionDate" v-model="sessionDate" validate="required"> -->
          <z-input
            v-model="sessionDate"
            name="sessionDate"
            label="Session Date"
            validate="required"
            type="date"
            @keyup="isSave = true"
            @change="isSave = true"
          />
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4"></div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <z-input
            v-model="session.belowZoneTime"
            name="belowZoneTime"
            label="Below Zone (min)"
            type="number"
            class="custom-number"
            min="0"
            @keyup="isSave = true"
            @change="isSave = true"
          />
        </div>
        <div class="col-md-4">
          <z-input
            v-model="session.inZoneTime"
            name="inZoneTime"
            label="In Zone (min)"
            type="number"
            class="custom-number"
            min="0"
            @keyup="isSave = true"
            @change="isSave = true"
          />
        </div>
        <div class="col-md-4">
          <z-input
            v-model="session.aboveZoneTime"
            name="aboveZoneTime"
            label="Above Zone (min)"
            type="number"
            class="custom-number"
            min="0"
            @keyup="isSave = true"
            @change="isSave = true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <z-input
            v-model="session.calories"
            name="session.calories"
            label="Calories"
            type="number"
            class="custom-number"
            min="0"
            @keyup="isSave = true"
            @change="isSave = true"
          />
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4"></div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col-md-6">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-5">
          <div class="custom-buttons">
            <button v-if="isSave" class="btn btn-primary me-2" @click="save()">
              Save
            </button>
            <div v-if="isSaving" class="custom-saving">
              <i class="fas fa-spinner fa-spin"></i
              ><span class="ms-2">saving...</span>
            </div>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZDialog from '@/Components/ZElements/Dialog'
import ZInput from '@/Components/ZElements/Input'
export default {
  name: 'session-add-dialog',
  components: {
    ZDialog,
    ZInput,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      isSaving: false,
      validErrors: [],
      invalidMessage: '',
      session: {
        belowZoneTime: 0,
        inZoneTime: 0,
        aboveZoneTime: 0,
        calories: 0,
        sessionDate: null,
        userId: null,
      },
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('usercardio', ['member', 'summary']),
    isVisible() {
      return this.show
    },
    title() {
      let _title = 'Add Workout'
      if (this.member) {
        _title += ` for ${this.member.firstName} ${this.member.lastName}`
      }
      return _title
    },
    id() {
      let _id = ''
      if (this.member) {
        _id = this.member.id
      }
      return _id
    },
    sessionDate: {
      get() {
        let _data = ''
        if (this.summary) {
          if (this.summary.week) {
            _data = moment(this.summary.week.value).format('YYYY-MM-DD')
            this.session.sessionDate = _data
          }
        }
        return _data
      },
      set(value) {
        this.session.sessionDate = moment.utc(value).format('YYYY-MM-DD')
      },
    },
  },
  methods: {
    ...mapActions('usercardio', ['createMemberSession']),
    init() {
      this.session = {
        belowZoneTime: 0,
        inZoneTime: 0,
        aboveZoneTime: 0,
        calories: 0,
        sessionDate: this.sessionDate,
        userId: this.member.id,
      }
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.session.sessionDate === null) {
        valid = false
        this.validErrors.push('session date')
      }
      return valid
    },
    async save() {
      this.invalidMessage = ''
      let success = false
      let valid = this.validate()
      if (valid) {
        this.isSave = false
        this.isSaving = true
        // Save Here
        console.log('Save Workout Session', this.session)
        let results = await this.createMemberSession(this.session)
        this.isSaving = false
        if (results.error) {
          this.invalidMessage = results.error
          this.isSave = true
        } else {
          success = true
          this.$emit('saved')
        }
      }
      return success
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-cardio-row {
  margin-top: 5px;
  border-top: 1px solid #dee2e6;
  padding-top: 5px;
}
.custom-cardio {
  padding: 5px;
}
.custom-saving {
  display: inline-block;
  margin-right: 10px;
}
</style>
